import { WSMutationConfig } from "@ws-react-query";
import {
  queriesNotifications,
  queriesPayers,
  queriesRequirements
} from "@query";
import { payersApi, personsApi } from "@api";
import { useSession } from "@hooks/useSession";
import { useWSMutation } from "../../../query/helpers";
import { QUERY_PAYER_ROWS } from "../../../query/search/payer/queries/useQueryPayerRows";
import { QUERY_PAYER_ROWS_SUMMARY } from "../../../query/search/payer/queries/useQueryPayerRowsSummary";
import { selectorPersonDisplayName } from "../../selectors/selectorPersonDisplayName";
import { buildTaxInformationConsent } from "../../utils/buildTaxInformationConsent";
import { WSServiceError } from "../../../utils/serviceHelper";
import { updateTaxVerificationRequirementCaches } from "./updateTaxVerificationRequirementCaches";

export const useMutationSubmit = (config?: WSMutationConfig<void>) => {
  const { personId } = useSession();

  return useWSMutation<any, WSServiceError, string[]>(
    async payerIds => {
      // TODO(v3): per-payer tax-information share. `payerId`s are v3 Payer ids (the modal now
      // sources them from listPayers). INTERIM consent: signature derived from the
      // payee's on-file legal name — DOUBLE-CHECK pending Legal sign-off; see
      // buildTaxInformationConsent.
      const person = await personsApi.getPerson({ personId });
      const consent = buildTaxInformationConsent({
        signature: selectorPersonDisplayName(person)
      });

      return await Promise.all(
        payerIds.map(payerId =>
          payersApi.shareTaxInformation({
            payerId,
            payerShareTaxInformationRequest: { consent }
          })
        )
      );
    },
    {
      dependencies: [
        queriesNotifications.listNotifications.queryKeyBase,
        QUERY_PAYER_ROWS,
        queriesPayers.getPayer.queryKeyBase,
        queriesPayers.listPayers.queryKeyBase,
        QUERY_PAYER_ROWS_SUMMARY,
        queriesRequirements.listPayeeRequirements.queryKeyBase,
        queriesRequirements.getPayeeRequirement.queryKeyBase
      ],
      onSuccess: (result, payerIds, c) => {
        // Optimistically update all cached requirement lists
        updateTaxVerificationRequirementCaches(payerIds);

        // Call user's onSuccess if provided
        config?.onSuccess?.(result, payerIds, c);
      },
      ...config
    }
  );
};
